import seaBreezeCafe from './places/sea-breeze-cafe.json';
import cornicheBites from './places/corniche-bites.json';
import vintageAlex from './places/vintage-alex.json';
import gleemBayRoastery from './places/gleem-bay-roastery.json';
import qaitbayCitadel from './places/qaitbay-citadel.json';
import sanStefanoBeach from './places/san-stefano-beach.json';
import bibliothecaAlexandrina from './places/bibliotheca-alexandrina.json';
import roushdyBistro from './places/roushdy-bistro.json';
import montazaPalaceGardens from './places/montaza-palace-gardens.json';
import sidiGaberSeafood from './places/sidi-gaber-seafood.json';
import stanleyBridgeView from './places/stanley-bridge-view.json';
import hiddenCourtyardCafe from './places/hidden-courtyard-cafe.json';
// Newly added — one place per previously empty category
import delicesPatisserie from './places/delices-patisserie.json';
import sidiBishrSweets from './places/sidi-bishr-sweets.json';
import anfoushiFishMarket from './places/anfoushi-fish-market.json';
import antoniadisGardens from './places/antoniadis-gardens.json';
import abuElAbbasMosque from './places/abu-el-abbas-mosque.json';
import cosmoBooks from './places/cosmo-books.json';
import cecilHotel from './places/cecil-hotel.json';
import sayedDarwishTheatre from './places/sayed-darwish-theatre.json';
import feluccaSunsetSail from './places/felucca-sunset-sail.json';
import workspaceAlexandria from './places/workspace-alexandria.json';
import alMaghrebHammam from './places/al-maghreb-hammam.json';
import nabiDanielStreet from './places/nabi-daniel-street.json';
// — Second wave: depth across thin categories —
import brazilianCoffee from './places/brazilian-coffee.json';
import coffeeRoasteryEast from './places/coffee-roastery-east.json';
import greekClub from './places/greek-club.json';
import kadouraRestaurant from './places/kadoura-restaurant.json';
import cleopatraDesserts from './places/cleopatra-desserts.json';
import baladyBakery from './places/balady-bakery.json';
import soukAttareen from './places/souk-attareen.json';
import glymBayBeach from './places/glym-bay-beach.json';
import shallalatGardens from './places/shallalat-gardens.json';
import pompeysPillar from './places/pompeys-pillar.json';
import catacombsKomShoqafa from './places/catacombs-kom-shoqafa.json';
import darMostakbalBooks from './places/dar-mostakbal-books.json';
import tolipHotel from './places/tolip-hotel.json';
import alexandriaOperaHouse from './places/alexandria-opera-house.json';
import saadZaghloulStreet from './places/saad-zaghloul-street.json';
// Cinemas
import renaissanceSanStefano from './places/renaissance-san-stefano.json';
import voxCinemasAlex from './places/vox-cinemas-alex.json';
import cinemaMetroAlex from './places/cinema-metro-alex.json';
import zahranMallCinema from './places/zahran-mall-cinema.json';
import greenPlazaRenaissance from './places/green-plaza-renaissance-cinema.json';
import cinemaRialto from './places/cinema-rialto.json';

export const CATEGORIES = [
// — Original core categories —
{
  slug: 'cafes',
  en: 'Cafes',
  ar: 'كافيهات',
  icon: 'Coffee',
  color: '#06B6D4'
},
{
  slug: 'restaurants',
  en: 'Restaurants',
  ar: 'مطاعم',
  icon: 'Utensils',
  color: '#C97B5C'
},
{
  slug: 'beaches',
  en: 'Beaches',
  ar: 'شواطئ',
  icon: 'Waves',
  color: '#0F3D5C'
},
{
  slug: 'attractions',
  en: 'Attractions',
  ar: 'معالم سياحية',
  icon: 'Landmark',
  color: '#E8D9C0'
},
{
  slug: 'museums',
  en: 'Museums',
  ar: 'متاحف',
  icon: 'Building',
  color: '#1A5A85'
},
{
  slug: 'viewpoints',
  en: 'Viewpoints',
  ar: 'إطلالات',
  icon: 'Mountain',
  color: '#B36A4D'
},
// — Extended categories —
{
  slug: 'bakeries',
  en: 'Bakeries & Patisseries',
  ar: 'مخابز وحلواني',
  icon: 'Croissant',
  color: '#D4A574'
},
{
  slug: 'sweets',
  en: 'Sweets & Ice Cream',
  ar: 'حلويات وآيس كريم',
  icon: 'IceCream',
  color: '#D67A7A'
},
{
  slug: 'markets',
  en: 'Markets & Bazaars',
  ar: 'أسواق وبازارات',
  icon: 'Store',
  color: '#B85450'
},
{
  slug: 'parks',
  en: 'Parks & Gardens',
  ar: 'حدائق ومتنزهات',
  icon: 'Trees',
  color: '#6B8E5A'
},
{
  slug: 'heritage',
  en: 'Heritage & Religious Sites',
  ar: 'مواقع تراثية ودينية',
  icon: 'Pyramid',
  color: '#8B4A3F'
},
{
  slug: 'bookshops',
  en: 'Bookshops & Libraries',
  ar: 'مكتبات ودور كتب',
  icon: 'Library',
  color: '#2D3E50'
},
{
  slug: 'hotels',
  en: 'Hotels & Stays',
  ar: 'فنادق وأماكن إقامة',
  icon: 'Hotel',
  color: '#C9A876'
},
{
  slug: 'cultural',
  en: 'Cultural Venues',
  ar: 'أماكن ثقافية',
  icon: 'Theater',
  color: '#7B5478'
},
{
  slug: 'cinemas',
  en: 'Cinemas',
  ar: 'سينمات',
  icon: 'Film',
  color: '#E50914'
},
{
  slug: 'activities',
  en: 'Activities & Experiences',
  ar: 'أنشطة وتجارب',
  icon: 'Compass',
  color: '#4A8B8B'
},
{
  slug: 'coworking',
  en: 'Coworking & Workspaces',
  ar: 'أماكن عمل مشتركة',
  icon: 'Briefcase',
  color: '#5A6B7B'
},
{
  slug: 'wellness',
  en: 'Wellness & Hammams',
  ar: 'عافية وحمامات',
  icon: 'Flower2',
  color: '#8FA585'
},
{
  slug: 'streets',
  en: 'Streets & Walks',
  ar: 'شوارع وممشى',
  icon: 'Footprints',
  color: '#8B7D6B'
}];


export type CatalogPlace = (typeof PLACES_CATALOG)[number];

export const PLACES_CATALOG = [
seaBreezeCafe,
cornicheBites,
vintageAlex,
gleemBayRoastery,
qaitbayCitadel,
sanStefanoBeach,
bibliothecaAlexandrina,
roushdyBistro,
montazaPalaceGardens,
sidiGaberSeafood,
stanleyBridgeView,
hiddenCourtyardCafe,
// Newly added — one place per previously empty category
delicesPatisserie,
sidiBishrSweets,
anfoushiFishMarket,
antoniadisGardens,
abuElAbbasMosque,
cosmoBooks,
cecilHotel,
sayedDarwishTheatre,
feluccaSunsetSail,
workspaceAlexandria,
alMaghrebHammam,
nabiDanielStreet,
// Second wave
brazilianCoffee,
coffeeRoasteryEast,
greekClub,
kadouraRestaurant,
cleopatraDesserts,
baladyBakery,
soukAttareen,
glymBayBeach,
shallalatGardens,
pompeysPillar,
catacombsKomShoqafa,
darMostakbalBooks,
tolipHotel,
alexandriaOperaHouse,
saadZaghloulStreet,
renaissanceSanStefano,
voxCinemasAlex,
cinemaMetroAlex,
zahranMallCinema,
greenPlazaRenaissance,
cinemaRialto];